<template>
    <div>
        <nav class="navbar navbar-fixed-bottom navbar-call background-info" v-if="show">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-2 col-md-2 col-lg-2 text-center text-danger">
                        <i class="fa fa-sun fa-spin"></i>&nbsp;Входящий звонок<br>
                        <span class="label label-primary">{{call.created_at | moment('DD.MM.YYYY HH:mm:ss')}}</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2">
                        <div class="strong text-primary h4">
                            <i class="fa fa-phone"></i>
                            {{client.phone}}
                        </div>
                        <div>
                        <span class="strong ng-binding fs11">
                            <router-link :to="{name: 'clients-edit', params: {id: client.id}}" target="_blank">
                                {{client.fullName ? client.fullName : 'Без имени'}}
                            </router-link>
                        </span>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                        <div class="h5" v-if="subscriptions.length > 0">
                            <span v-if="subscriptions.length === 1">
                                Активный абонемент
                            </span>
                            <span v-else>
                                Активные абонементы
                            </span>:
                            <div>
                                <span
                                        v-for="subscription in subscriptions"
                                        v-bind:key="subscription.id"
                                        :class="{
                                            'subscription--active': subscription.status === 1,
                                            'subscription--no-active': subscription.status === 0,
                                        }"
                                >
                                    {{subscription.name}}
                                    (Остаток: {{subscription.count}} до {{subscription.date_expire | moment('DD.MM.YYYY', 'YYYY-MM-DD')}})
                                </span>
                            </div>
                        </div>
                        <div v-else class="h5">Нет активных абонементов</div>
                        <div class="h5" v-if="reservations.length > 0">
                            Резерв:
                            <div>
                                <span
                                        v-for="reservation in reservations"
                                        v-bind:key="reservation.id"
                                >
                                    {{reservation.date | moment('DD.MM.YYYY', 'YYYY-MM-DD')}}
                                    с {{reservation.time_start | moment('HH:mm', 'HH:mm:ss')}}
                                    - {{reservation.direction}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2">
                        <div class="h5">
                            Последнее посещение:<br>
                            <span v-if="lastVisit">
                                {{lastVisit | moment('DD.MM.YYYY', 'YYYY-MM-DD')}}
                            </span>
                            <span v-else>Нет</span>
                        </div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2">
                        <button class="btn btn-primary mr5" v-on:click="takeCall">
                            <i class="glyphicon glyphicon-earphone"></i> Принят
                        </button>
                        <button v-on:click="close" class="btn btn-danger">Закрыть <i class="glyphicon glyphicon-remove"></i></button>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import Client from "../models/v2/Client";
    import moment from 'moment';
    import Call from "../models/v2/Call";
    export default {
        beforeCreate() {
            this.sockets.subscribe('incoming_call', async data => {
                this.isLoading = true;
                this.time = moment();
                this.call = new Call(data.call);
                this.client = new Client(data.client);
                this.lastVisit = data.lastVisit;
                this.reservations = data.reservations;
                this.subscriptions = data.subscriptions;
                this.isLoading = false;
                this.show = true;
            });
        },
        beforeDestroy() {
            this.sockets.unsubscribe('incoming_call');
        },
        data() {
            return {
                isLoading: false,
                show: false,
                time: null,
                client: new Client(),
                call: new Call(),
                lastVisit: '',
                reservations: [],
                subscriptions: [],
            };
        },
        methods: {
            close: function() {
                this.show = false;
            },
            takeCall: async function() {
                this.isLoading = true;

                await this.call.setTakeCall();

                this.isLoading = false;

                this.close();
            },
        },
    }
</script>
